import { hasValue } from "../../../utils/functions.js";
import TableList from "../../sub-components/Generic/TableList/TableList.vue";
export default {
  name: "holidays",
  components: {
    TableList
  },
  data() {
    return {
      loadingList: false,
      filter: this.FilterDefault(),

      headers: [
        { field: "Code", label: "Código", classHeader: 'text-left', classField: 'text-left'},
        { field: "Name", label: "Nome", classHeader: 'text-left', classField: 'text-left' },
        { field: "Date", label: "Data", type: "date", classHeader: 'text-left', classField: 'text-left' },
      ],
      itemList: [],
      pagination: {
        RowsPerPage: 30,
        PageNumber: 1,
        TotalItems: 0
      },
      countFilter: 0
    };
  },
  watch: {
    "pagination.PageNumber"() {
      this.ListHoliday();
    },
    "pagination.RowsPerPage"() {
      this.ListHoliday();
    }
  },
  mounted() {
    this.ListHoliday();
  },
  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListHoliday();
    },
    ResetFilter() {
      this.filter = this.FilterDefault()
      this.ListHoliday();
    },
    FilterDefault() {
      return {
        Code: null,
        Name: null,
        Year: new Date().getFullYear()
      };
    },
    ListHoliday() {
      this.loadingList = true;

      this.countFilter = 0;
      Object.values(this.filter).map(value => { if (hasValue(value)) this.countFilter++ });

      const params = this.GetParams();

      this.$store
        .dispatch("ListHoliday", params)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os feriados", error);
        })
        .finally(() => (this.loadingList = false));
    },

    GetParams(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name,
        "Object.Year": this.filter.Year
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/Holidays/Holidays.js